import r from "react";
import { useTranslation as T } from "react-i18next";
import { ProgrammeType as j } from "../../../api/models/loyalty/loyaltyProgramme/loyaltyProgrammeConfiguration/loyaltyProgrammeSettings/programmeSettingsTypes.js";
import { LoyaltyProgrammeCodeType as q } from "../../../api/models/loyalty/loyaltyProgramme/loyaltyProgrammeConfiguration/loyaltyProgrammeDesign/loyaltyProgrammeDesignTypes.js";
import { LoyaltyProgrammeStatus as G } from "../../../api/models/loyalty/loyaltyProgramme/loyaltyProgrammeEnums.js";
import { getCurrentLanguage as H } from "../../../i18n/i18n.js";
import { useStyle as J } from "../../../dom/hooks/useStyle.js";
import { AddToWallet as K } from "../AddToWallet/AddToWallet.js";
import { LoyaltyProgressType as d, LoyaltyProgress as X } from "../LoyaltyProgress/LoyaltyProgress.js";
import { LoyaltyScanDisplay as Y } from "../LoyaltyScanDisplay/LoyaltyScanDisplay.js";
import i from "./loyaltyCard.module.scss.js";
const $ = 300;
function me({
  cashbackAccount: t,
  loyaltyAccount: e,
  walletUrl: o
}) {
  var c, p, _, C, u, E, N, v, b, L, P, B, I, S, h, F, x, R, k, D, O, V, W, w, z, Q;
  const m = ((p = (c = e.tier.configuration) == null ? void 0 : c.design) == null ? void 0 : p.font) ?? "Quicksand";
  J(`https://fonts.googleapis.com/css?family=${encodeURIComponent(m)}&display=swap`);
  const {
    t: n
  } = T(), s = H(), g = e.loyalty.status !== G.ACTIVE;
  let l = e.loyalty.configuration.settings.programmeType === j.POINT ? d.BAR : d.STAMP;
  (C = (_ = e.tier.configuration) == null ? void 0 : _.design) != null && C.balanceProgressVisibility || (l = d.NONE);
  const a = (E = (u = e.tier.configuration) == null ? void 0 : u.design) == null ? void 0 : E.texts, f = (a == null ? void 0 : a.headline[s]) ?? (a == null ? void 0 : a.headline.default), M = (a == null ? void 0 : a.deactivate[s]) ?? (a == null ? void 0 : a.deactivate.default);
  return /* @__PURE__ */ r.createElement(
    "div",
    {
      "data-testid": "loyalty-card",
      className: i.cardWrapper,
      style: {
        fontFamily: m,
        "--cardSize": `${$}px`,
        "--highlightColor": ((v = (N = e.tier.configuration) == null ? void 0 : N.design) == null ? void 0 : v.highlightColor) ?? "#565656",
        "--backgroundColor": ((L = (b = e.tier.configuration) == null ? void 0 : b.design) == null ? void 0 : L.backgroundColor) ?? "#dddddd",
        "--cardColor": ((B = (P = e.tier.configuration) == null ? void 0 : P.design) == null ? void 0 : B.cardColor) ?? "#FFF",
        "--contentTextColor": ((S = (I = e.tier.configuration) == null ? void 0 : I.design) == null ? void 0 : S.contentTextColor) ?? "#aaaaaa"
      }
    },
    /* @__PURE__ */ r.createElement("div", { className: i.card }, /* @__PURE__ */ r.createElement(
      X,
      {
        type: l,
        maxValue: e.maxBalance,
        value: e.balance,
        backgroundColor: ((F = (h = e.tier.configuration) == null ? void 0 : h.design) == null ? void 0 : F.stampsColor) ?? "#ea565c",
        backgroundImage: (R = (x = e.tier.configuration) == null ? void 0 : x.design) == null ? void 0 : R.cardBackgroundImage,
        maxWidth: $,
        progressBarColor: ((D = (k = e.tier.configuration) == null ? void 0 : k.design) == null ? void 0 : D.progressBarColor) ?? "#ea565c",
        stampImage: ((V = (O = e.tier.configuration) == null ? void 0 : O.design) == null ? void 0 : V.currencyLogo) ?? ""
      },
      g && /* @__PURE__ */ r.createElement("div", null, M || n("loyaltyCard.disabled"))
    ), /* @__PURE__ */ r.createElement("div", { className: i.card__scanCodes }, /* @__PURE__ */ r.createElement(
      Y,
      {
        type: ((W = e.loyalty.configuration.design) == null ? void 0 : W.codeType) ?? q.QR_CODE,
        data: e.userId,
        disabled: g
      }
    )), /* @__PURE__ */ r.createElement("div", { className: i.card__customerName }, e.userFullName), /* @__PURE__ */ r.createElement("div", { className: i.card__info }, /* @__PURE__ */ r.createElement("div", null, /* @__PURE__ */ r.createElement("div", { className: i.card__info__title }, ((z = (w = e.tier.configuration) == null ? void 0 : w.design) == null ? void 0 : z.labelLevelName) || n("tier")), /* @__PURE__ */ r.createElement("div", { className: i.card__info__content }, e.tier.name)), /* @__PURE__ */ r.createElement("div", { className: i.card__info__rightSide }, /* @__PURE__ */ r.createElement("div", { className: i.card__info__title }, !t && (e.loyalty.configuration.settings.currencyName || n("points")), t && t.currency), /* @__PURE__ */ r.createElement("div", { className: i.card__info__content }, !t && /* @__PURE__ */ r.createElement(r.Fragment, null, e.balance, "/", e.maxBalance), t && t.balance))), o && /* @__PURE__ */ r.createElement(K, { url: o }), f && /* @__PURE__ */ r.createElement("div", { className: i.card__prelude }, f)),
    ((Q = e.loyalty.configuration.design) == null ? void 0 : Q.legalUrl) && /* @__PURE__ */ r.createElement(
      "div",
      {
        className: i.terms,
        onClick: () => {
          var U;
          return window.open((U = e.loyalty.configuration.design) == null ? void 0 : U.legalUrl, "_blank");
        }
      },
      n("terms.title")
    )
  );
}
export {
  me as LoyaltyCard
};
//# sourceMappingURL=LoyaltyCard.js.map
